import React from 'react'
import type { TabsProps } from './Tabs.types'

export default function Tabs({ tabs, activeKey, onSelect }: TabsProps) {
  return (
    <div className="custom-tabs-buttons mb-3 pb-3">
      {tabs.map(tab => (
        <button
          key={tab.key}
          className={`rd-btn rd-btn--medium ${tab.key === activeKey ? 'rd-btn--primary' : 'rd-btn--tab'}`}
          role="tab"
          type="button"
          aria-selected={tab.key === activeKey}
          onClick={() => onSelect(tab.key)}
        >
          {tab.title}
        </button>
      ))}
    </div>
  )
}
